// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"cfa0c8fd","95":"ffb3615b","326":"a4e49bb6","383":"cc6bacee","717":"5e7433f2","867":"5e7433f2","908":"ffb3615b"}[chunkId] + ".chunk.css";
};